import { render, staticRenderFns } from "./NodeGiaPha.vue?vue&type=template&id=c2bef18a&scoped=true&"
import script from "./NodeGiaPha.vue?vue&type=script&lang=js&"
export * from "./NodeGiaPha.vue?vue&type=script&lang=js&"
import style0 from "./NodeGiaPha.vue?vue&type=style&index=0&id=c2bef18a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bef18a",
  null
  
)

export default component.exports